import { useContext, useEffect } from "react"
import { Box, Typography, Stack, Tabs, Tab, Button } from "@mui/material"
import { MainInformation } from "./MainInformation"
import { PropertyImages } from "./PropertyImages"
import { PropertyLocation } from "./PropertyLocation"
import { OtherInformation } from "./OtherInformation"
import { useHistory }  from 'react-router-dom';
import { ToolContext } from "../../../../../core/context/ToolContext"
import { TxtEmail } from "../../../../../core/global/Format"
import { validateMobile, ValidUrl } from "../../../../../core/validator/Validator"
import { rqx } from "../../../../../core/request/API"
import { env } from "../../../../../core/Env"
import { InputsErrMsg } from "../../../../../core/global/InputErrMsg"
import { SnakeLoader } from "../../../../../core/loader/SnakeLoader"
import { S3 } from "../../../../../core/transmit/S3"
import { Confirmation } from "../../../../../core/global/Confirmation"
import { SuccessMsg } from "../../../../../core/global/SuccessMsg"
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material'

export const Forms = ({ company_id, user_id }) => {
    const { realproperty_state } = useContext(ToolContext);
    const { dataLocations, confirmation, mainInfrmtn, otherInfrmtn, dfltMainInfrmtn, dfltOtherInfrmtn } = realproperty_state;
    const nav = useHistory();
    const dcde = window.atob(new URLSearchParams(window.location.search).get('pkey'))
    const tab = new URLSearchParams(window.location.search).get('tab');
    const list_id = Number(dcde.replace('prm_', ''));
    
    const handleTabChange = (_, newVal) => {
        const p = new URLSearchParams(window.location.search);
        p.set('tab', newVal)
        nav.push(`${window.location.pathname}?${p.toString()}`);
    }

    const getSpcfcPrprtyData = async () => {
        confirmation.set((p) => ({...p, loader: true}))
        try {
            const res_attach = await rqx.get(`<<tool>>/${env()}/propertyListing/attactment`, { id: list_id})
            const res_data = await rqx.get(`<<tool>>/${env()}/propertyListing/read_spcfc_list`, { company_id: company_id, id: list_id})
            if (res_data) {
                const data = res_data[0];
                const arrayOfObjects = typeof JSON.parse(data.indoor_facilities)[0] === 'object';
                const li = JSON.parse(data.listing_information);
                const pr = JSON.parse(data.price);
                const contact_buyer = JSON.parse(data.description_design);
                getProvCity('province', data.province_id);
                getProvCity('city', data.city_id);
                mainInfrmtn.set(p => ({ 
                    ...p,
                    listingTitle: { ...mainInfrmtn.data.listingTitle, value: data.name },
                    description: data.description,
                    ownerType: { ...mainInfrmtn.data.ownerType, value: data.owner_type },
                    offerType: { ...mainInfrmtn.data.offerType, value: data.offer_type },
                    propertyType: { ...mainInfrmtn.data.propertyType, value: data.property_type_id },
                    subType: { ...mainInfrmtn.data.subType, value: data.property_subtype_id },
                    condominiumName: li.condo_name,
                    subdivisionName: li.subdivision_name,
                    buildingName: li.building_name,
                    unitNoFloorNo: li.un_with_fn,
                    blockLotUnitFloorNo: li.baluf_number,
                    bedroom: li.bedroom,
                    bathroom: li.bath_room,
                    floorArea: li.floor_area,
                    landSize: li.land_size,
                    forClosure: data.foreclosure,
                    preSelling: data.pre_selling,
                    price: { ...mainInfrmtn.data.price, value: pr.price || "" },
                    monthly: { ...mainInfrmtn.data.monthly, value: pr.monthly || "" },
                    yearly: { ...mainInfrmtn.data.yearly, value: pr.yearly || "" },
                    showPrice: data.show_price, 
                    availableFrom: { ...mainInfrmtn.data.availableFrom, value: data.available_date },
                    property_seller_information: { 
                        contactPerson: { ...mainInfrmtn.data.property_seller_information.contactPerson, 
                            value: `${data.first_name} ${data.last_name}`
                        },
                        email: { ...mainInfrmtn.data.property_seller_information.email, value: data.email },
                        mobileNumber: { ...mainInfrmtn.data.property_seller_information.mobileNumber, value: data.phone_number }
                    },
                }))
                otherInfrmtn.set(p => ({
                    ...p,
                    status: data.status,
                    listing_contact_id: data.listing_contact_id,
                    province: { ...otherInfrmtn.data.province, value: data.province_id },
                    city: { ...otherInfrmtn.data.city, value: data.city_id },
                    barangay: { ...otherInfrmtn.data.barangay, value: data.barangay_id || ''},
                    streetNumber: data.street_building_number,
                    indoorFacilities: { ...otherInfrmtn.data.indoorFacilities, 
                        value: arrayOfObjects ? JSON.parse(data.indoor_facilities).map(v => v.id) : JSON.parse(data.indoor_facilities),
                    },
                    outdoorFacilities:  { ...otherInfrmtn.data.outdoorFacilities, 
                        value: arrayOfObjects ? JSON.parse(data.outdoor_facilities).map(v => v.id) : JSON.parse(data.outdoor_facilities),
                    },
                    isAgreedToPay: { ...otherInfrmtn.data.isAgreedToPay, value: data.agree_commission || 0 },
                    youtubeLink: { ...otherInfrmtn.data.youtubeLink, value: res_attach[0].youtube_link },
                    photos: res_attach,
                    checkList: JSON.parse(data.property_checklist),
                    detailStatus: data.listing_detail_status || 1,
                    contact_details_for_buyers: { ...otherInfrmtn.data.contact_details_for_buyers, 
                        firstName: { ...otherInfrmtn.data.contact_details_for_buyers.firstName, value: contact_buyer?.first_name || "" },
                        lastName: { ...otherInfrmtn.data.contact_details_for_buyers.lastName, value: contact_buyer?.last_name || "" },
                        email: { ...otherInfrmtn.data.contact_details_for_buyers.email, value: contact_buyer?.email || "" },
                        mobileNumber: { ...otherInfrmtn.data.contact_details_for_buyers.mobileNumber, value: contact_buyer?.mobileNumber || "" }
                    },
                }))
            }
            confirmation.set((p) => ({...p, loader: false}))
        } catch (err) {
            console.error("Failed to fetch data", err);
        }
    }
    
    useEffect(() => {
        getSpcfcPrprtyData();
        // eslint-disable-next-line
    }, [])
    
    // function to get city and province
    const getProvCity = async ( name, value ) => {
        if (name === "province") {
            const res_cities = await rqx.get(`<<global>>/${env()}/location/city`, { ref: "province_id", filter: JSON.stringify([value]) });
            dataLocations.set((p) => ({
                ...p,
                cities: res_cities || [],
            }));
        }
        if (name === "city") {
            const res_barangays = await rqx.get(`<<global>>/${env()}/location/barangay`, { ref: "city_id", filter: JSON.stringify([value]) });
            dataLocations.set((p) => ({
                ...p,
                barangays: res_barangays || [],
            }));
        } 
    }

    const handleChange = (e, type) => {
        const { name, value } = e.target;
        getProvCity(name, value);
        if (["listingTitle", "price", "monthly", "yearly", "availableFrom", "province", "city", "barangay", "firstName", "lastName", "email", "mobileNumber"].includes(name)) {
            const isValid = value !== "";
            type.set((p) => ({
                ...p,
                [name]: { 
                ...p[name],
                    value,
                    stat: name === "email" ? !TxtEmail(value) : name === "mobileNumber" ? !validateMobile(value) : !isValid },
                ...(name === "province" && {
                    city: { ...type.data.city, value: "" },
                }),
                ...((name === "province" || name === "city") && { barangay: { ...type.data.barangay, value: "" },
                }),
            }))
            return;
        }
        type.set((p) => ({ ...p, [name]: value }))
    }
    // validating when submit button is clicked
    const isInputsValidSYP = () => {
        const mainFormInputs = Object.entries(mainInfrmtn.data).filter(([k, v]) => k !== 'property_seller_information' && typeof v === "object" && v !== null && !Array.isArray(v) && (mainInfrmtn.data.offerType.value === 1 ? k !== "monthly" && k !== "yearly" : k !== "price")).map(([k, v]) => {
            if (k === "listingTitle" || k === "monthly" || k === "yearly" || k === "price" || k === "availableFrom") {
                const val = typeof v?.value === 'number' ? v.value.toString() : v?.value ?? "";
                v.msg = !val.trim() ? dfltMainInfrmtn.data[k].msg : "";
                v.stat = !val.trim();
            } else {
                v.msg = v.value ? "" : dfltMainInfrmtn.data[k].msg;
                v.stat = !v?.value;
            }
            return v;
        })
        const hasExistingPhoto = otherInfrmtn.data.photos.filter(v => v.photo_type === 1).some(v => v.active === 1 && v.data_status === 'InUse');
        const otherFormInputs = Object.entries(otherInfrmtn.data).filter(([_, v]) => typeof v === "object" && v !== null && !Array.isArray(v)).map(([k, v]) => {
            if (k === "province" || k === "city") {
                v.msg = v.value ? "" : dfltOtherInfrmtn.data[k].msg;
                v.stat = !v?.value;
            } else if (k === "morePhotos") {
                v.msg = (v.b64Imgs.length > 0 || hasExistingPhoto) ? "" : dfltOtherInfrmtn.data[k].msg;
                v.stat = !(v.b64Imgs.length > 0 || hasExistingPhoto); 
            } else if (k === "youtubeLink") {
                v.msg = !v?.value.trim() ? "" : !ValidUrl(v.value) ? dfltOtherInfrmtn.data[k].msg : "";
                v.stat = !v?.value.trim() ? false : !ValidUrl(v.value) ? true : false;
            }
            return v;
        }).concat(
            Object.entries(otherInfrmtn.data.contact_details_for_buyers).map(([k, v]) => {
                if (k === "email") {
                    v.msg = !TxtEmail(v.value) ? dfltOtherInfrmtn.data.contact_details_for_buyers[k].msg : "";
                    v.stat = !TxtEmail(v.value);
                } else if (k === "mobileNumber") {
                    v.msg = !validateMobile(v.value) ? dfltOtherInfrmtn.data.contact_details_for_buyers[k].msg : "";
                    v.stat = !validateMobile(v.value);
                } else {
                    v.msg = !v?.value.trim() ? dfltOtherInfrmtn.data.contact_details_for_buyers[k].msg : "";
                    v.stat = !v?.value.trim();
                }
                return v;
            }),
        );

        if ([...mainFormInputs, ...otherFormInputs].some((v) => v.stat)) {
            confirmation.set((p) => ({
                ...p, hasInvalidInputs: true,
            }))
            return false;
        }
        return true;
    }

    const handlePublishedModal = (v) => {
        if (tab === 'other-information') {
            isInputsValidSYP() && confirmation.set((p) => ({ ...p, publishConfirmation: v === 'open' }))
        } else {
            const p = new URLSearchParams(window.location.search);
            p.set('tab', tab === 'main-information' ? 'property-images' : tab === 'property-images' ? 'property-location' : 'other-information')
            nav.push(`${window.location.pathname}?${p.toString()}`);
        }
    }

    const handlePublished = async () => {
        confirmation.set((p) => ({ ...p, listUpdatingLoader: true }))
        try {
            // existing more photos new details with updated cover photo
            let exstngPht = [];
            if (otherInfrmtn.data.propertyCoverPhoto.b64Img) {
                const coverPhotoId = otherInfrmtn.data.photos.find(v => v.photo_type === 2)?.id;
                const getLink = await S3(otherInfrmtn.data.propertyCoverPhoto.objectImg);
                const updatedPhotos = otherInfrmtn.data.photos.map(photo =>
                    photo.id === coverPhotoId ? 
                        { ...photo, 
                            link: getLink.location, 
                            name: otherInfrmtn.data.propertyCoverPhoto.name, 
                            size: otherInfrmtn.data.propertyCoverPhoto.size, 
                            type: otherInfrmtn.data.propertyCoverPhoto.type }
                        : photo
                );
                otherInfrmtn.set((p) => ({
                    ...p,
                    photos: updatedPhotos
                }));
                exstngPht = updatedPhotos;
            }
            // check if cover photo is changing
            let morePhotos = [];
            if (otherInfrmtn.data.morePhotos.b64Imgs.length > 0) {
                morePhotos = await Promise.all (
                    otherInfrmtn.data.morePhotos.imgProperties.map(async (v) => {
                        const getLink = await S3(v.objectImg);
                        const { objectImg, ...p } = v;
                        return {
                            ...p,
                            link: getLink.location,
                            youtube_link: otherInfrmtn.data.youtubeLink.value,
                            id: "",
                            listing_id: list_id
                        };
                    })
                )
            }
            const final_photos = [...(exstngPht.length === 0 ? otherInfrmtn.data.photos : exstngPht), ...morePhotos];
            const body = {
                id: list_id,
                companyId: company_id,
                userId: user_id,
                status: 2,
                ownerType: mainInfrmtn.data.ownerType.value, 
                offerType: mainInfrmtn.data.offerType.value, 
                propertyType: mainInfrmtn.data.propertyType.value, 
                subType: mainInfrmtn.data.subType.value, 
                listing_information: { 
                    bedroom: mainInfrmtn.data.bedroom,
                    bath_room: mainInfrmtn.data.bathroom,
                    land_size: mainInfrmtn.data.landSize,
                    condo_name: mainInfrmtn.data.condominiumName,
                    floor_area: mainInfrmtn.data.floorArea,
                    un_with_fn: mainInfrmtn.data.unitNoFloorNo,
                    baluf_number: mainInfrmtn.data.blockLotUnitFloorNo,
                    building_name: mainInfrmtn.data.buildingName,
                    subdivision_name: mainInfrmtn.data.subdivisionName,
                },
                forClosure: mainInfrmtn.data.forClosure,
                preSelling: mainInfrmtn.data.preSelling, 
                price:  mainInfrmtn.data.price.value === "" 
                    ? { yearly: mainInfrmtn.data.yearly.value, monthly: mainInfrmtn.data.monthly.value }
                    : { price: mainInfrmtn.data.price.value },
                showPrice: mainInfrmtn.data.showPrice, 
                availableFrom: mainInfrmtn.data.availableFrom.value, 
                listingTitle: mainInfrmtn.data.listingTitle.value, 
                description: mainInfrmtn.data.description, 
                province: otherInfrmtn.data.province.value, 
                city: otherInfrmtn.data.city.value, 
                barangay: otherInfrmtn.data.barangay.value || 0, 
                streetNumber: otherInfrmtn.data.streetNumber, 
                indoorFacilities: otherInfrmtn.data.indoorFacilities.value, 
                outdoorFacilities: otherInfrmtn.data.outdoorFacilities.value, 
                youtubeLink: otherInfrmtn.data.youtubeLink.value, 
                photos: final_photos, 
                checkList: otherInfrmtn.data.checkList, 
                agree_commission: otherInfrmtn.data.isAgreedToPay.value, 
                listing_detail_status: otherInfrmtn.data.detailStatus, 
                contact_details_for_buyers: {
                    first_name: otherInfrmtn.data.contact_details_for_buyers.firstName.value, 
                    last_name: otherInfrmtn.data.contact_details_for_buyers.lastName.value, 
                    email: otherInfrmtn.data.contact_details_for_buyers.email.value, 
                    mobileNumber: otherInfrmtn.data.contact_details_for_buyers.mobileNumber.value, 
                }
            }

            const res = await rqx.post(`<<tool>>/${env()}/propertyListing/update_requested_listing`, body)
            if (res.message === 'success') {
                confirmation.set((p) => ({...p, isListUpdated: true}))
                setTimeout(() => {
                    window.location.href = '/realproperty/requested-listing';
                }, 1500);
            }
        } catch (err) {
            console.error("Failed to update status", err);
        } 
    }

    const handleSoldModal = (v) => {
        confirmation.set((p) => ({ ...p, soldConfirmation: v === 'open' }))
    }

    const handleSold = async () => {
        confirmation.set((p) => ({ ...p, soldUpdatingLoader: true }));
         try {
            const body = {
                id: list_id,
                userId: user_id,
                active: 0, // mark as disabled when sold
                status: 3, // mark as sold
            }
            const res = await rqx.post(`<<tool>>/${env()}/propertyListing/update_sold`, body)
            if (res.message === 'success') {
                confirmation.set((p) => ({...p, isSoldUpdated: true }))
                setTimeout(() => {
                    window.location.href = '/realproperty/requested-listing';
                }, 1500);
            }
        } catch (err) {
            console.error("Failed to update status", err);
        } 
    }

    return (
        <Box pt='1rem'>
            <Stack flexDirection="row" gap="1rem" alignItems="center" mb="0.5rem">
                <ArrowBackIcon onClick={() => nav.push(`/realproperty/requested-listing`)} sx={{ color: "primary.main", cursor: "pointer", transition: "0.25s" ,':hover': { color: "grey" }, }}/>
                <Typography fontSize="1.25rem" fontWeight="600">Update and confirm property details for buyer review.</Typography>
            </Stack>
            { confirmation.data.loader ? 
                <Box display="flex" justifyContent="center" mt="4rem"><SnakeLoader size="12px" bg="#11783C" distance="8px" /></Box>
            :
                <>
                    <Tabs value={tab} onChange={handleTabChange} sx={{ mb: "1rem" }}>
                        <Tab label="Main Information" value='main-information'/>
                        <Tab label="Property Images" value='property-images'/>
                        <Tab label="Property Location" value='property-location'/>
                        <Tab label="Other Information" value='other-information'/>
                    </Tabs>
                    { 
                        tab === 'main-information' ? <MainInformation handleChange={handleChange}/>
                        :
                        tab === 'property-images' ? <PropertyImages/>
                        :
                        tab === 'property-location' ? <PropertyLocation handleChange={handleChange}/>
                        :
                        tab === 'other-information' ? <OtherInformation handleChange={handleChange}/>
                        :
                        <Box> Oops! Looks like you're lost. Page not found! </Box> 
                    }
                    <Stack my="2rem" flexDirection="row" justifyContent="center" gap="5rem">
                        <Button variant="outlined" size="large" color="error" sx={{ width: "10rem" }} onClick={() => nav.push(`/realproperty/requested-listing`)}> Cancel </Button>
                        <Button disabled={ otherInfrmtn.data.status === 3 } variant="contained" size="large" onClick={() => handlePublishedModal('open')} 
                            sx={{ width: "10rem", ...(tab !== 'other-information' && { bgcolor: '#1976d2', '&:hover': { bgcolor: '#115293' }}) }} > 
                                { tab !== 'other-information' ? 'Next' : 'Publish' } 
                        </Button>
                        <Button disabled={ otherInfrmtn.data.status === 3 } variant="contained" size="large" color="warning" sx={{ width: "10rem" }} onClick={() => handleSoldModal('open')}> Sold </Button>
                    </Stack>
                    { confirmation.data.publishConfirmation && <Confirmation isOpen={confirmation.data.publishConfirmation} cancel={() => handlePublishedModal('close')} send={() => handlePublished()} disabled={confirmation.data.isListUpdated} text="Update and Published this property listing?" btnText="Confirm"/>}
                    { confirmation.data.soldConfirmation && <Confirmation isOpen={confirmation.data.soldConfirmation} cancel={() => handleSoldModal('close')} send={() => handleSold()} disabled={confirmation.data.isSoldUpdated} text="Mark this property as sold?" btnText="Confirm"/>}
                    { confirmation.data.isListUpdated && <SuccessMsg open={confirmation.data.isListUpdated} setOpen={(v) => confirmation.set(p => ({ ...p, isListUpdated: v }))} message="Success" bgcolor="#d2f9e2" hideDuration={2000}/> }
                    { confirmation.data.isSoldUpdated && <SuccessMsg open={confirmation.data.isSoldUpdated} setOpen={(v) => confirmation.set(p => ({ ...p, isSoldUpdated: v }))} message="Success" bgcolor="#d2f9e2" hideDuration={2000}/> }
                    <InputsErrMsg open={confirmation.data.hasInvalidInputs} setOpen={(value) => confirmation.set({ ...confirmation.data, hasInvalidInputs: value })} message="Please complete all required fields with valid information!" ckColor="#d32f2f" bgcolor="#fcd2cf"  /> 
                </>
            }
        </Box>
    )
}
